import api from 'services/financial/company'

export const getCompanies = async () => {
  let res = await api.list()

  return res?.data?.data ?? []
}
